import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api, withQuery, quantity, date, isoDate } from '../api.js';

/**
 * Лист за преброяване — печата се празен, служителят в склада попълва
 * намерените бройки на хартия, операторът ги връща в „Ревизия" после.
 *
 * Затова колоната „Намерено" е само линия за писане, не поле за въвеждане
 * — тази страница не пипа базата, само показва каквото системата смята в
 * момента на печата.
 */
export default function PrintRevisionSheet() {
  const [params] = useSearchParams();
  const warehouseId = params.get('warehouseId');
  const groupId = params.get('groupId');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(withQuery('/api/reports/revision-sheet', { warehouseId, groupId }))
      .then(setData)
      .catch((e) => setError(e.message));
  }, [warehouseId, groupId]);

  if (error) return <div className="error" style={{ margin: 20 }}>{error}</div>;
  if (!data) return <div className="empty">Зареждане…</div>;

  return (
    <>
      <div className="print-toolbar">
        <button className="primary" onClick={() => window.print()}>Печат</button>
        <div style={{ flex: 1 }} />
        <button onClick={() => window.close()}>Затвори</button>
      </div>

      <div className="print-page">
        <div className="print-title">
          <h1>ЛИСТ ЗА ПРЕБРОЯВАНЕ</h1>
          <div className="sub">
            {data.warehouse?.name} · {data.group?.name} · {date(isoDate())}
          </div>
        </div>

        <table className="print-lines">
          <thead>
            <tr>
              <th style={{ width: '8mm' }}>№</th>
              <th>Наименование</th>
              <th>Бележка / характеристики</th>
              <th style={{ width: '14mm' }}>Мярка</th>
              <th className="num" style={{ width: '20mm' }}>Наличност</th>
              <th className="num" style={{ width: '26mm' }}>Намерено</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((it, i) => (
              <tr key={it.product_id}>
                <td>{i + 1}</td>
                <td>{it.name}</td>
                <td>{[it.note, it.properties_text].filter(Boolean).join(' · ')}</td>
                <td>{it.unit}</td>
                <td className="num">{quantity(it.quantity)}</td>
                <td className="num" />
              </tr>
            ))}
            {data.items.length === 0 && (
              <tr><td colSpan={6} className="empty">Няма стоки в тази група</td></tr>
            )}
          </tbody>
        </table>

        <div className="signatures">
          <div>
            <div className="line" />
            Преброил
          </div>
          <div>
            <div className="line" />
            Дата
          </div>
        </div>
      </div>
    </>
  );
}
